import { all, takeEvery, put, call } from 'redux-saga/effects';
import { initialize } from '../actions';
import { SelectGroup, SelectGroupActionType, selectGroupSuccess } from '../actions/selectGroupActions';
import { mixpanelClearOrgContext } from '../analytics';
import { postActiveUserGroupId } from '../api/updateSettings';
import { getSelectedGroupFromStorage, setSelectedGroupInStorage } from '../components/findUserType';
import { GroupType } from '../models/commonEnums';
import { SelectedGroup } from '../models/commonTypeScript';
import history from '../store/history';

export function* selectGroupSaga({ userGroupId, groupType }: SelectGroup): Generator {
    const currentSelectedGroup: SelectedGroup | null = getSelectedGroupFromStorage();

    if (currentSelectedGroup?.userGroupId === userGroupId) {
        yield put(selectGroupSuccess());
        return;
    }

    setSelectedGroupInStorage({ userGroupId, groupType });

    // Clear org-related Mixpanel super properties immediately on switch
    mixpanelClearOrgContext();

    if (
        !(groupType === GroupType.consumer && currentSelectedGroup?.groupType === GroupType.consumer) &&
        (groupType === GroupType.consumer || currentSelectedGroup?.groupType === GroupType.consumer)
    ) {
        // Going to or coming from consumer version requires a full reload
        if (!currentSelectedGroup?.userGroupId) {
            window.location.reload();
        } else window.location.assign('/');
    } else if (currentSelectedGroup?.userGroupId) {
        yield put(selectGroupSuccess());
        history.push('/');
    }
    yield call(postActiveUserGroupId, userGroupId);
    yield put(initialize());
}

export default function* selectGroupSagas(): Generator {
    yield all([takeEvery(SelectGroupActionType.SelectGroupInit, selectGroupSaga)]);
}
